/* eslint-disable no-lonely-if */

import { getFCCFlowName, fccConstantValues } from '../../common/Helpers';

export const ExternalHeaderAndFooterIntegration = () => {
  let gnavcsssrc = '';
  let gnavsrc = '';
  const { site } = getFCCFlowName();
  window.gnavdl = { bu: 'corporate', appid: site !== fccConstantValues?.NationalRetailerFlow ? 'corpweb' : 'natlretailer' };
  if (window.location.host === 'www.verizon.com' || window.location.host === 'wwwordering-prod-east-yz.vpc.verizon.com') {
    gnavcsssrc = 'https://www.verizon.com/etc/designs/vzwcom/gnav20/core.css';
  } else {
    if (site === fccConstantValues?.NationalRetailerFlow) {
      gnavcsssrc = 'https://vzwqa1.sdc.vzwcorp.com/etc/designs/vzwcom/gnav20/core.css';
    } else if (site !== fccConstantValues?.NationalRetailerFlow) {
      gnavcsssrc = 'https://vzwqa2.sdc.vzwcorp.com/etc/designs/vzwcom/gnav20/core.css';
    }
  }
  if (window.location.host === 'www.verizon.com' || window.location.host === 'wwwordering-prod-east-yz.vpc.verizon.com') {
    gnavsrc = 'https://www.verizon.com/etc/designs/vzwcom/gnav20/corporate.js';
  } else {
    gnavsrc = 'https://vzwqa2.sdc.vzwcorp.com/etc/designs/vzwcom/gnav20/corporate.js';
  }
  if (gnavcsssrc !== '') {
    const fileref = document.createElement('link');
    fileref.type = 'text/css';
    fileref.rel = 'stylesheet';
    fileref.href = gnavcsssrc;
    const dom = document.getElementsByTagName('head');
    if (dom && dom?.[0]) {
      dom[0].appendChild(fileref);
    }
  }
  if (gnavsrc !== '') {
    const fileref = document.createElement('script');
    fileref.setAttribute('type', 'text/javascript');
    fileref.setAttribute('src', gnavsrc);
    fileref.setAttribute('async', true);
    const dom = document.getElementsByTagName('head');
    if (dom && dom?.[0]) {
      dom[0].appendChild(fileref);
    }
  }
};
